import rut from "@/helpers/rut";
import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import Button from "../Button";
import Input from "../Input";
import Label from "../Label";
import { useUsersRegistrationContext } from "@/context/UsersRegistration";

const Form = ({
    onSubmit,
    onInputChange = () => {},
    onAction = () => {},
    users = [],
    ticketsQuantity = 1,
    processing,
}) => {

    const { setIsAutocompleteResponsible, isAutocompleteResponsible, responsibleForAssistants } = useUsersRegistrationContext();

    const handleCheckboxSelectAll = (event) => {
        const action = event.target.checked ? 'SELECT_ALL' : 'DESELECT_ALL';
        onAction && onAction(action);
    }

    return (
        <form onSubmit={(e) => onSubmit && onSubmit(e)}>
            {!responsibleForAssistants && (
                <div className="flex items-center gap-2 justify-end mb-4">
                    <Input id="checkbox-select-all-assumed_guest" type="checkbox" handleChange={handleCheckboxSelectAll} />
                    <Label forInput="checkbox-select-all-assumed_guest" value="Cada asistente asume su responsabilidad" />
                </div>
            )}
            <div className="flex flex-col gap-8">
                {responsibleForAssistants ? (
                    <div className="mt-4">
                        El responsable de la orden se hace cargo de todos los asistentes
                    </div>
                ) : [...Array(parseInt(ticketsQuantity))].map((_, index) => {
                    const user = users.find((user) => user.id === index + 1);
                    const inputsAreDisabled = isAutocompleteResponsible && user?.id === 1;

                    return (
                        <div
                            key={`input-list-item-user-registration-${
                                index + 1
                            }-out-${ticketsQuantity}`}
                        >
                            <div
                                className={classNames("grid grid-cols-1 w-full gap-2 items-center", {
                                    "sm:grid-cols-2": user?.assumed_guest,
                                    "sm:grid-cols-3": !user?.assumed_guest,
                                })}
                            >
                                <div className="mb-2">
                                    <Label value="Nombre" forInput={"name-" + user?.id} />
                                    <Input
                                        id={"name-" + user?.id}
                                        className="w-full"
                                        type="text"
                                        name="name"
                                        placeholder="Nombre"
                                        handleChange={(event) =>
                                            onInputChange(event, index)
                                        }
                                        value={user?.name || ""}
                                        required
                                        disabled={inputsAreDisabled}
                                    />
                                </div>
                                <div>
                                    <Label
                                        value="Apellido"
                                        forInput={"lastname-" + user?.id}
                                    />
                                    <Input
                                        id={"lastname-" + user?.id}
                                        className="w-full"
                                        type="text"
                                        name="lastname"
                                        placeholder="Apellido"
                                        handleChange={(event) =>
                                            onInputChange(event, index)
                                        }
                                        value={user?.lastname || ""}
                                        required
                                        disabled={inputsAreDisabled}
                                    />
                                </div>
                                {
                                    !user?.assumed_guest && (
                                        <div>
                                            <Label value="R.U.N" forInput={"rut-" + user?.id} />
                                            <Input
                                                id={"rut-" + user?.id}
                                                className={classNames("w-full", {
                                                    "cursor-not-allowed": user?.assumed_guest
                                                })}
                                                type="text"
                                                name="rut"
                                                placeholder={user?.assumed_guest ? "Asistente" : "R.U.N"}
                                                handleChange={(event) =>
                                                    onInputChange(event, index, {
                                                        value:
                                                            rut.format(
                                                                event.target.value
                                                            ) === "-"
                                                                ? ""
                                                                : rut.format(
                                                                    event.target
                                                                        .value
                                                                ),
                                                    })
                                                }
                                                value={user?.rut || ""}
                                                disabled={user?.assumed_guest || inputsAreDisabled}
                                                required={!user?.assumed_guest}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                            <div className={classNames({
                                "grid grid-cols-1 gap-1": user?.id === 1
                            })}>
                                <div className="flex w-full items-center gap-1">
                                    <Input
                                        id={"assumed_guest-" + user?.id}
                                        type="checkbox"
                                        name="assumed_guest"
                                        handleChange={(event) => {
                                            onInputChange(event, index, {
                                                value: !user?.assumed_guest,
                                                extra: [
                                                    {
                                                        name: 'rut',
                                                        value: ''
                                                    }
                                                ]
                                            });
                                        }}
                                        checked={!user?.assumed_guest}
                                        disabled={isAutocompleteResponsible && user?.id === 1}
                                    />
                                    <Label
                                        value={<p><span className="text-lg"></span>Asume responsabilidad individual</p>}
                                        forInput={"assumed_guest-" + user?.id}
                                    />
                                </div>
                                {user?.id === 1 && (
                                    <div className="flex w-full items-center gap-1">
                                        <Input
                                            id={"is_autocomplete-" + user?.id}
                                            type="checkbox"
                                            name="is_autocomplete"
                                            handleChange={(event) => setIsAutocompleteResponsible(event.target.checked)}
                                            checked={isAutocompleteResponsible}
                                        />
                                        <Label
                                            value={<p>Completar con los datos del responsable</p>}
                                            forInput={"is_autocomplete-" + user?.id}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            {/* <p className="pt-4">* El asistente asume su propia responsabilidad.</p> */}
            {onSubmit && (
                <div className="flex items-center justify-center mt-8">
                    <Button processing={processing}>Continuar</Button>
                </div>
            )}

        </form>
    );
};

export default Form;
